import React from 'react';
import { Show, List, TabbedShowLayout, Tab, Datagrid, EditButton, TextField, ReferenceField, ReferenceManyField, DateField, TopToolbar, RefreshButton, ListButton,usePermissions } from 'react-admin';
import { CamelCaseField, ExpectedDateField } from "../digitalOrders/common";
import { getLocalStorageKey } from "../common/common";
import { useLocation } from "react-router-dom";
// import Modal from 'react-responsive-modal';
// import Spinner from '../../src/spinner';
// import myDataProvider from '../myRestProvider';
// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };
// class ExampleApp extends React.Component {
//     constructor(props) {
//         super(props);
//         this.fetchItem(props.record.business_id);
//         this.reload = this.reload.bind(this);
//         this.state = {
//             open: false,
//             showloader: true,
//             reloadButton: false,
//             data: {},
//             dateFlag: false
//         };
//         console.log('permission', props)
//         console.log('id is', props.record.business_id)
//     }
//     onOpenModal = () => {
//         console.log(this.props);
//         this.setState({ open: true, reloadButton:false });
//         this.fetchItem(this.props.record.business_id);
//     };
//     onCloseModal = () => {
//         this.setState({ open: false });
//     };
//     render() {
//         const { open } = this.state;
//         return (
//             <div className="detailsBtn">
//                   <p onClick={this.onOpenModal}>Check balance</p>
//                 <Modal open={open} onClose={this.onCloseModal} center>
//                     <table>
//                         <tr>
//                             <th>SAP credit area Cd</th>
//                             <th>Last SAP update</th>
//                             <th>Currency</th>
//                             <th>Credit limit</th>
//                             <th>Credit exposure SAP</th>
//                             <th>Orders not invoiced price</th>
//                             <th>Digital order balance</th>
//                         </tr>
//                         <tr>
//                             <td>{this.state.data.sapCreditAreaCd}</td>
//                             {this.state.dateFlag && this.state.data.lastSAPUpdate &&
//                                 <td >{this.state.data.lastSAPUpdate}</td>}
//                             <td>{this.state.data.currency}</td>
//                             <td>{this.state.data.creditLimit}</td>
//                             <td>{this.state.data.creditExposureSAP}</td>
//                             <td>{this.state.data.orders_not_invoiced_price}</td>
//                             <td>{this.state.data.sap_digital_order_balance}</td>
//                         </tr>
//                         <tr className='errorMsg'>
//                             <td colspan="7">{this.state.reloadButton &&
//                                 <div>{this.state.data.msgText}</div>
//                             }</td>
//                         </tr>
//                         <tr>
//                             <td className='spinner' colspan="7"><div className="spinner">
//                                 {this.state.showloader && window.navigator.onLine &&
//                                     <Spinner />
//                                 }
//                             </div>
//                                 {this.state.reloadButton && window.navigator.onLine &&
//                                     <div className="refresh" >
//                                         <i onClick={this.reload} class="material-icons">
//                                             refresh
//                        </i>
//                                     </div>
//                                 }
//                                 <div>
//                                 {!window.navigator.onLine &&
//                                <p>It seems that you are offline. Please check your internet connection</p>
//                                 }
//                                 </div>

//                                 </td>
//                         </tr>
//                     </table>
//                 </Modal>
//             </div >
//         );
//     }
//     reload() {
//         this.setState({
//             reloadButton: false,
//             showloader: true
//         }, () => this.fetchItem(this.props.record.business_id));
//     }

//     fetchItem = async (id) => {
//         this.setState({ showloader: true, data: {} },
//             async () => {
//                 const json = await myDataProvider(GET_ONE, 'getSapDetails', { id });
//                 const item = json.data;
//                 var countryTime = new Date(item.lastSAPUpdate).toLocaleString("en-US");
//                 console.log('countryTime', countryTime);
//                 this.setState({
//                     showloader: false,
//                     data: {
//                         ...item,
//                         lastSAPUpdate: countryTime,
//                     },
//                     reloadButton: item.errorMsg === 'Reload',
//                     dateFlag: countryTime !== 'Invalid Date',
//                 });
//             });
//     }
// }

const ShowActions = ({ basePath, data }) => (
  <TopToolbar>
    <RefreshButton />
    <ListButton basePath={basePath} />
    <EditButton basePath={basePath} record={data} />
  </TopToolbar>
);

const ShowTitle = ({ record }) => {
  return record && <span>Ship-To Site {record.name}</span>;
};

const ShipTosShow = ({ ...props }) => {
  console.log("props ==>", props);
  const permissions = usePermissions();
  const showAllOrders = getLocalStorageKey("show_all_orders");
  const location = useLocation();
  const pathSplit = location.pathname.split("/");
  const businessIdVal = pathSplit[2];
  return (
<Show actions={<ShowActions permissions={permissions.permissions} />} {...props} title={<ShowTitle />}>
      <TabbedShowLayout Class="tab-scroll">
        <Tab label="Ship-To Details" contentClassName="scrollTab">
          <ReferenceField
            label="Sold To Name"
            source="business_id"
            reference="businesses"
            link="show"
            allowEmpty
          >
            <TextField source="name" />
          </ReferenceField>
          <TextField source="name" />

          <TextField source="ship_to_sap_number" label="Ship To ID" />

          <TextField source="phone" />

          <DateField 
          // label="Created at" 
          source="created_at" />
          {/* {permissions === 'isSap' &&
                        <ExampleApp id={props.id} />
                    } */}
        </Tab>
        <Tab label="Contracts">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: "created_at", order: "DESC" }}
            reference="sap_contracts"
            source="ship_to_sap_number"
            target="partner_sap_code"
            className="tab-pagination"
          >
            <List actions={false} {...props} sort={{ field: 'created_at', order: 'DESC' }}  filterDefaultValues={{ sap_business_site_id: businessIdVal }} exporter={false}>
              <Datagrid rowClick="show" bulkActionButtons={false}>
                <TextField source="contract_number" />
                <TextField source="contract_type" />
                <ReferenceField
                  label="Sold To Name"
                  sortable={false}
                  // source="ship_to_sites.business_id"
                  source="retailer_info.id"
                  reference="businesses"
                  link="show"
                  allowEmpty
                >
                  <TextField source="name" />
                </ReferenceField>
                <TextField
                  source="retailer_info.sap_code"
                  // label="Sold To ID"
                  sortable={false}
                />
                <DateField
                  label="Contract Valid From"
                  source="contract_valid_from"
                />
                <DateField
                  label="Contract Valid To"
                  source="contract_valid_to"
                />
                <TextField source="inco_term" />
                <DateField
                  // label="Created at"
                  source="created_at"
                  sortable={false}
                />
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
        <Tab label="Orders">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: 'created_at', order: 'DESC' }}
            reference={showAllOrders ? "sap_digital_orders" : "sap_digital_app_orders"}
            source="id"
            target="sap_business_site_id"
            className="tab-pagination"
          >
            <List actions={false} {...props} filterDefaultValues={{ sap_business_site_id: businessIdVal }} exporter={false}>
              <Datagrid rowClick="show" className="tab-data-grid" bulkActionButtons={false}>
                <DateField label="Order Date" source="creation_date" />
                <ReferenceField
                  label="Sold To Name"
                  source="business_id"
                  reference="businesses"
                  link="show"
                  allowEmpty
                >
                  <TextField source="name" />
                </ReferenceField>
                <TextField source="order_number" />
                <CamelCaseField
                  source="mode_of_delivery"
                  label="Mode Of Delivery"
                />
                <ExpectedDateField
                  // label="Expected Date"
                  source="delivery_date_from"
                />
                <TextField 
                // label="Local PO Note" 
                source="customer_ref_number" />
                <TextField
                  label="Order Status"
                  source="customer_order_status_desc"
                />
                <ReferenceField
                  label="Ship To Name"
                  source="sap_business_site_id"
                  reference="sap_business_sites"
                  link="show"
                  allowEmpty
                >
                  <TextField source="name" />
                </ReferenceField>
                {permissions === "isSap" && (
                  <DateField label="Date 1st seen in LR" source="created_at" />
                )}
                {permissions === "isSap" && showAllOrders && (
                  <TextField label="Is App Order" source="is_app_order" />
                )}
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default ShipTosShow;
